export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/shop-cart-btn-bg-fb354e8a557fb97d88cb2036f0cef48d.png";